import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { zoneSelectStyle } from 'common/ZoneSelect/ZoneSelect.style';
var statusItems = [
    { label: 'All Accounts', value: '' },
    { label: 'Paused', value: 'Paused' },
    { label: 'Unpaused', value: 'Unpaused' },
];
/**
 * @description Component to display pause status filter
 * @function CWMemberPauseStatusSelect
 */
var CWMemberPauseStatusSelect = function (_a) {
    var _b = _a.statusType, statusType = _b === void 0 ? '' : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var classes = zoneSelectStyle({ hasAllOption: true }).classes;
    return (_jsx(Select, { disabled: disabled, displayEmpty: true, value: statusType, onChange: onChange, className: classes.root, inputProps: {
            'data-testid': 'pause-status-select',
        }, onClick: function (e) {
            e.stopPropagation();
        }, children: statusItems.map(function (status) { return (_jsx(MenuItem, { value: status.value, children: status.label }, status.label)); }) }));
};
export default CWMemberPauseStatusSelect;
